/************
 -- General
 ************/

 function freezeSwiper(swiper) {
  if (!swiper || !swiper.wrapperEl) return;
  swiper.wrapperEl.style.transitionDuration = '0ms';
}

function unfreezeSwiper(swiper) {
  if (!swiper || !swiper.wrapperEl) return;
  requestAnimationFrame(() => {
    swiper.wrapperEl.style.transitionDuration = '';
  });
}

// localized
const productPage = document.querySelector('#product');

// quantity
let quantity = 1;

// ATC button
const productATCButton = productPage.querySelector('#productATC');

function isDiscontinuedVariant(variant) {
    if (!variant) return false;
    const discontinuedIds = Array.isArray(window.discontinuedVariantIds) ? window.discontinuedVariantIds : [];
    return discontinuedIds.includes(Number(variant.id));
}

// wait for load and check if product has been saved
document.addEventListener("DOMContentLoaded", async () => {
    // check if product is in wishlist
    const wishlist = await getWishList();
    productPage.querySelectorAll('.wishlistAdd').forEach(el => {
        const handle = el.dataset.handle;
        if (wishlist.includes(handle)) el.classList.add("active");
    })
})

/**********************
 -- Product Announcement
 **********************/

// close announcement bar
productPage.querySelector('#productAnnouncementButton')?.addEventListener('click', function () {
    this.parentElement.remove();
});

/******************
 -- Product Swiper
 ******************/
  setTimeout(function () {
    const swiperContainer = document.querySelector(".productSwiper_swiper #productSwiper");

if (swiperContainer) {
    let productImages = new Swiper(".productSwiper_swiper #productSwiper", {
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        zoom: {
            maxRatio: 3,
            toggle: false
        },
        on: {
            slideChange: function () {
                // if overlay is active, remove
                document.querySelector('#productSwiperImageOverlay').classList.remove('active');
                document.querySelectorAll('.productSwiperPlay.active')?.forEach(async active => {
                    active.classList.remove('active');
                    await active.querySelector('video').pause();
                })
                // change over active class
                document.querySelectorAll("#productThumbnails .productThumbnailItem.active").forEach(el => el.classList.remove("active"));
                const slideGroup = document.querySelectorAll("#productThumbnails .productThumbnailItem");
                slideGroup[this.activeIndex]?.classList.add("active");
            }
        }
    });

// thumbnail images for swiper
productPage.querySelectorAll(".productThumbnailItem").forEach((item, index) => {
  item.addEventListener("click", () => {
    productImages.slideTo(index);

    const images = document.querySelectorAll(
      "#productSwiper .productSwiperImageVariant"
    );

    images.forEach(img => img.classList.remove("active"));
    if (images[index]) {
      images[index].classList.add("active");
    }
  });
});


}else{
// thumbnail images for swiper
productPage.querySelectorAll(".productThumbnail").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this.parentElement);
        // change active slide
        productImages.slideTo(index);
    });
});
    // setup product swiper
let productImages = new Swiper("#productSwiper", {
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        zoom: {
            maxRatio: 3,
            toggle: false
        },
        on: {
            slideChange: function () {
                // if overlay is active, remove
                document.querySelector('#productSwiperImageOverlay').classList.remove('active');
                document.querySelectorAll('.productSwiperPlay.active')?.forEach(async active => {
                    active.classList.remove('active');
                    await active.querySelector('video').pause();
                })
                // change over active class
                document.querySelectorAll("#productThumbnails .productThumbnailItem.active").forEach(el => el.classList.remove("active"));
                document.querySelectorAll("#productThumbnails .productThumbnailItem.matched-variant-thumb.activeess").forEach(el => el.classList.remove("activeess"));
                const slideGroup = document.querySelectorAll("#productThumbnails .productThumbnailItem");
                // slideGroup[this.activeIndex]?.classList.add("active");
                const thumbnails = document.querySelectorAll("#productThumbnails .productThumbnailItem.matched-variant-thumb");
                const nextThumbnail = thumbnails[this.activeIndex - 1];
                nextThumbnail.classList.add("activeess");
            }
        }
    });

productPage.querySelectorAll(".productThumbnail").forEach(function (element) {
  element.addEventListener("click", function () {
  const matchedThumb = this.closest(".matched-variant-thumb");
    if (matchedThumb) {
      const matchedThumbs = Array.from(document.querySelectorAll(".matched-variant-thumb"));
      const index = matchedThumbs.indexOf(matchedThumb) + 1;
      productImages.slideTo(index);
    }else{
       productImages.slideTo(0);
    }
  });
});
}
 }, 300); 
// videos
document.querySelectorAll('.productSwiperPlay').forEach(playBtn => {
    playBtn.addEventListener('click', async function () {
        const video = this.querySelector('video');
        if (video) {
            if (this.classList.contains('active')) {
                await video.pause();
                this.classList.remove('active');
            } else {
                // Pause other videos before playing this one
                document.querySelectorAll('.productSwiperPlay video').forEach(v => {
                    v.pause();
                    v.closest('.productSwiperPlay')?.classList.remove('active');
                });

                await video.play();
                this.classList.add('active');
            }
        }
    });
});


/**************
 -- Tabs
 ***************/

// tab section
const productTabs = productPage.querySelector('#productTabs');

// each tab title, reveal and hide related info
productPage.querySelectorAll('.productTabsItemButton')?.forEach(button => {
    button.addEventListener('click', function () {

        //stop any videos
        if (productTabs?.querySelector('.productTabsItemVideo.active')) {
            productTabs.querySelectorAll('.productTabsItemVideo.active').forEach(el => {
                el.classList.remove('active');
                el.querySelector("video").pause();
            })
        }

        this.classList.toggle('active');
    })
})

// make sure there is at least one video
if (productTabs?.querySelector('.productTabsItemVideo')) {
// play videos on tabs
    productTabs.querySelectorAll('.productTabsItemVideo').forEach(el => {
        el.addEventListener('click', async function () {
            if (this.classList.contains('active')) {
                // pause this one
                this.classList.remove('active');
                await this.querySelector("video").pause();
            } else {
                // stop all videos
                if (productTabs.querySelector('.productTabsItemVideo.active')) {
                    productTabs.querySelectorAll('.productTabsItemVideo.active').forEach(el => {
                        el.classList.remove('active');
                        el.querySelector("video").pause();
                    })
                }
                // play this one
                this.classList.add('active');
                await this.querySelector("video").play();
            }
        })
    })
}

/**************
 -- Modals
 ***************/

// get BNPL modal
const bnplModal = document.querySelector('.bnpl');

// get Shipping Notice modal
const shippingNoticeModal = productPage.querySelector('#shippingNotice');

// get notification modal
const notificationModal = productPage.querySelector('#notification');

// BNPL Modal
productPage.querySelector('.productShippingItem.bnpl')?.addEventListener('click', () => {
    openModal(bnplModal);
})

// Shipping Notice Modal
productPage.querySelectorAll('.productShippingItem.shipping')?.forEach(el => {
    el.addEventListener('click', () => {
        openModal(shippingNoticeModal);
    })
})

// notification form submission
notificationModal?.querySelector('#notificationForm')?.addEventListener("submit", async function (e) {
    e.preventDefault();

    // confirm everything is provided
    let valid = true;
    this.querySelectorAll('[name]').forEach(function (element) {
        if (!element.value) {
            valid = false;
        }
    });

    if (!valid) {
        alert('Please make sure you fill out all fields.');
        return;
    }

    // validate email
    const emailCheck = validateEmail(this.querySelector('#email').value);
    if (!emailCheck) return;

    // start loading
    this.querySelector('button').classList.add('loading');

    // send KlaviyoBackInStockRequest
    sendKlaviyoBackInStockRequest(this.querySelector('#email').value, activeVariant?.id);

    // check for newsletter opt in
    if (document.querySelector("#notificationLabelCheck").checked) {
        // add to newsletter
        // fetch("https://api.maltertech.com/jadore/newsletter.php", {
        //     method: "POST",
        //     body: new URLSearchParams({
        //         email: this.querySelector('#email').value,
        //         store: Shopify.shop,
        //     })
        // });
        const email = this.querySelector('#email').value;

        fetch('https://script.google.com/macros/s/AKfycbyxK8gWprCdgtaq_mIJZGIiOJS0YLrSD03v58D4KbWzaPhZfMxYQKx1xQ9Z_cB57jcq1w/exec?action=subscribeCustomerToMarketing', {
          method: 'POST',
          body: JSON.stringify({ email: email })
        })
        .then(response => response.json())
        .then(data => {
          console.log('✅ Response from GAS:', data);
          // Optionally show success message
        })
        .catch(error => {
          console.error('❌ Error:', error);
          // Optionally show error message
        });
        
    }

    // end loading
    this.querySelector('button').classList.remove('loading');
    this.classList.add('success');

    // swap content and add close to new button
    this.closest('#notificationInner').classList.add('success');
    notificationModal.querySelector('#notificationBtnConfirmed')?.addEventListener('click', () => {
        notificationModal.close();
    })
})

/****************
 -- Update Product
 *****************/

productPage.querySelectorAll('input').forEach(input => {
    if (input.classList.contains('colorSelectorMobileVariantsItemInput')) return;
    if (input.classList.contains('productAddonsItemCheckInput')) return;
    input.addEventListener('change', () => {
        updateProduct(this.selectedIndex)
            .catch(e => console.error(e));
    });
})

productPage.querySelectorAll('select').forEach(select => {
    if (select.classList.contains('productAddonsItemSelect')) return;
    if (select.classList.contains('productAddonsItemDialogSelect')) return;
    select.addEventListener('change', function () {
        // update the display to match select option
        document.querySelectorAll('.productOptionsItemValuesColorLayoutItem.active')?.forEach(item => item.classList.remove('active'));
        document.querySelector(`.productOptionsItemValuesColorLayoutItem[data-index="${this.selectedIndex}"]`)?.classList.add('active');
        // update the mobile text display
        productPage.querySelectorAll('.productOptionsItemValuesColorSelectMobileIndicatorItem')?.forEach(el => el.classList.remove('active'));
        productPage.querySelector(`.productOptionsItemValuesColorSelectMobileIndicatorItem[data-index="${this.selectedIndex}"]`)?.classList.add('active');
        updateProduct(this.selectedIndex)
            .catch(e => console.error(e));
    });
})

// variant color images
productPage.querySelectorAll('.productOptionsItemValuesColorLayoutItem')?.forEach(item => {
    item.addEventListener('click', function () {
        if (this.classList.contains('active')) return;
        // update the display color
        this.closest('.productOptionsItemValuesColorLayout')
            .querySelectorAll('.productOptionsItemValuesColorLayoutItem.active')
            .forEach(el => el.classList.remove('active'));
        this.classList.add('active');
         // update the select option - specifically target the hidden select
         const hiddenSelect = this.closest('.productOptionsItem').querySelector('select#hiddenSelect');
         if (hiddenSelect) {
             hiddenSelect.selectedIndex = this.dataset.index;
             hiddenSelect.dispatchEvent(new Event('change'));
         } 
    });
})

// mobile select
productPage.querySelectorAll('.productOptionsItemValuesColorSelectMobileIndicator').forEach(el => {
    el.addEventListener('click', function () {
        openModal(productPage.querySelector('.colorSelectorMobile'));
    })
})

// mobile select
productPage.querySelectorAll('.colorSelectorMobileVariantsItemInput').forEach(input => {
    input.addEventListener('change', function () {
        // activate the hidden select option via the color displays
        productPage.querySelectorAll('.productOptionsItemValuesColorLayoutItem')?.forEach(el => el.classList.remove('active'));
        productPage.querySelector(`.productOptionsItemValuesColorLayoutItem[data-index="${this.dataset.index}"]`)?.click();
        // update the mobile text display
        productPage.querySelectorAll('.productOptionsItemValuesColorSelectMobileIndicatorItem')?.forEach(el => el.classList.remove('active'));
        productPage.querySelector(`.productOptionsItemValuesColorSelectMobileIndicatorItem[data-index="${this.dataset.index}"]`).classList.add('active');
        // close the dialog
        productPage.querySelector('.colorSelectorMobile').close();
    })
})

// mobile close
productPage.querySelectorAll('.colorSelectorMobileTopExit')?.forEach(exit => {
    exit.addEventListener('click', function () {
        this.closest('.colorSelectorMobile')?.close()
    })
})

// Handle radio button changes for non-color options
productPage.querySelectorAll('.productOptionsItemValuesLabelInput')?.forEach(input => {
    input.addEventListener('change', function () {
        if (this.checked) {
            // Trigger updateProduct when radio button selection changes
            updateProduct()
                .catch(e => console.error(e));
        }
    });
})

// Handle clicks on the label itself to ensure variant selection works
productPage.querySelectorAll('.productOptionsItemValuesLabel')?.forEach(label => {
    label.addEventListener('click', function () {
        const input = this.querySelector('.productOptionsItemValuesLabelInput');
        if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change'));
        }
    });
})

async function updateProduct(index = null) {

    // Find the active variant
    if (product.variants.length === 1) {
        // default fallback
        activeVariant = product.variants[0];
    } else {
        // collect options from inputs
        let options = [];

        productPage.querySelectorAll(`select`)?.forEach(select => {
            if (select.classList.contains('productAddonsItemSelect')) return;
            if (select.classList.contains('productAddonsItemDialogSelect')) return;
            options.push(select.value);
        });

        // Collect options from variant selection radio buttons specifically
        productPage.querySelectorAll('.productOptionsItemValuesLabelInput:checked')?.forEach(input => {
            options.push(input.value);
        });
        
        // Also collect from other checked inputs (excluding specific classes)
        productPage.querySelectorAll(`input:checked`)?.forEach(input => {
            if (input.classList.contains('productOptionsItemValuesLabelInput')) return; // Already handled above
            if (input.classList.contains('colorSelectorMobileVariantsItemInput')) return;
            if (input.classList.contains('productAddonsItemCheckInput')) return;
            // Skip inputs with generic values
            if (input.value === 'on' || input.value === 'off') return;
            options.push(input.value);
        });

        // find new variant based on the options
        activeVariant = product.variants.find((variant) => {
            return (JSON.stringify(variant.options) === JSON.stringify(options) || JSON.stringify(variant.options) === JSON.stringify(options.reverse()))
        });
        
        // If no variant found, try a more flexible matching approach
        if (!activeVariant && options.length > 0) {
            activeVariant = product.variants.find((variant) => {
                // Check if all selected options match the variant options (order independent)
                return options.every(option => variant.options.includes(option));
            });
        }
    }

    // check if variant wasn't found
    if (!activeVariant) {
        // Fallback: try to find variant by index if provided
        if (index !== null && product.variants[index]) {
            activeVariant = product.variants[index];
        } else {
            // Last resort: use first available variant
            activeVariant = product.variants.find(v => v.available) || product.variants[0];
        }
    }

    /**************
     Variant Image
     ***************/

    // change color on first slide to selected
    if (index || index === 0) {
        // main swiper
        productPage?.querySelectorAll('.productSwiperImageVariant.active')?.forEach(item => item.classList.remove('active'));
        productPage?.querySelector(`.productSwiperImageVariant[data-index="${index}"]`)?.classList.add('active');
        if (typeof productImages !== 'undefined') {
          productImages.slideTo(0);
        }
        // thumbnail
        productPage?.querySelectorAll('.productThumbnail.active')?.forEach(thumbnail => thumbnail.classList.remove('active'));
        productPage?.querySelectorAll('.productThumbnail')[index]?.classList.add('active');
    }

    // if has secondary image, add to overlay on swiper
    const colorSelect = productPage.querySelector('.productOptionsItemValuesColorLayoutItem.active');
    if (colorSelect) {
        if (colorSelect.dataset.image !== "https://cdn.shopify.com/s/files/1/2597/5920/?width=800") {
            document.querySelector('#productSwiperImageOverlay').src = colorSelect.dataset.image;
            document.querySelector('#productSwiperImageOverlay').classList.add('active');
        } else {
            document.querySelector('#productSwiperImageOverlay').classList.remove('active');
        }
    }

    /**************
     Price
     ***************/

    if (productPage.querySelector("#productATC")) {
        if (!productPage.querySelector("#productATC").classList.contains('noCustomer')) {
            const compareEl = productPage.querySelector("#productCompare");
            const realEl = productPage.querySelector("#productPrice");

            if (activeVariant.compare_at_price > activeVariant.price) {
                compareEl.textContent = price(activeVariant.compare_at_price * quantity, false);
            } else {
                compareEl.textContent = "";
            }
            realEl.textContent = price(activeVariant.price * quantity, false);

            // update after pay element
            // if (document.querySelector('square-placement')) {
            //     document.querySelector('square-placement').dataset.amount = (activeVariant.price * quantity / 100).toString();
            // }
        }
    }

    /**************
     ATC Enable/Disable
     ***************/

    if (productPage.querySelector("#productATC")) {
        if (!productPage.querySelector("#productATC").classList.contains('noCustomer')) {
            // check if the variant is in stock or marked discontinued
            const discontinuedVariant = isDiscontinuedVariant(activeVariant);
            if (activeVariant.available) {
                productATCButton.disabled = false;
                productATCButton.removeAttribute("aria-disabled");
                productATCButton.classList.remove("notification");
                productPage.querySelector("#productATCText").textContent = "Add To Cart";
            } else if (discontinuedVariant) {
                productATCButton.disabled = true;
                productATCButton.setAttribute("aria-disabled", "true");
                productATCButton.classList.remove("notification");
                productATCButton.querySelector('#productATCText').textContent = "Sold Out";
            } else {
                productATCButton.disabled = false;
                productATCButton.removeAttribute("aria-disabled");
                productATCButton.classList.add("notification");
                productATCButton.querySelector('#productATCText').textContent = "Sold Out - Notify Me";
            }
        }
    }

    // update url with variant id so the selected options are maintained on refresh
    let url = new URL(window.location.href);
    url.searchParams.set("variant", activeVariant.id);
    window.history.replaceState({}, "", url);
}

// close background overlay when clicked
document.querySelector('#productSwiperImageOverlay').addEventListener('click', function () {
    this.classList.remove('active');
});

// on load, update the product
updateProduct()
    .catch(e => console.error(e));

// incremental and decremental buttons
productPage.querySelector('.productVariantSpecAmountSelector')?.addEventListener('click', function (e) {
    // prevent bubbling to parent
    e.stopPropagation();

    // if minus clicked subtract from quantity
    if (e.target.classList.contains('productVariantSpecAmountSelectorLess')) {
        // can not go below 1
        if (quantity === 1) return
        // subtract from amount and display
        quantity--;
    } else if (e.target.classList.contains('productVariantSpecAmountSelectorMore')) {
        // add to amount and display
        quantity++;
    } else {
        return;
    }
    // update
    this.querySelector('.productVariantSpecAmountSelectorDisplay').textContent = quantity.toString();
    updateProduct(product.variants.findIndex(v => v.id === activeVariant.id)).catch(err => console.error(err));
})

/*******************
 -- Product Addons --
 ********************/

productPage.querySelectorAll('.productAddonsItemDialogOpen')?.forEach(button => {
    button.addEventListener('click', function () {
        openModal(this.closest('.productAddonsItem').querySelector('.productAddonsItemDialog'));
    })
})

productPage.querySelectorAll('.productAddonsItemDialogExit')?.forEach(exit => {
    exit.addEventListener('click', function () {
        this.closest('.productAddonsItemDialog').close();
    })
})

productPage.querySelectorAll('.productAddonsItemSelect')?.forEach(select => {
    select.addEventListener('change', function () {
        addOnImages(this);
        this.closest('.productAddonsItem').querySelector('.productAddonsItemDialogSelect').selectedIndex = this.selectedIndex;
        if (this.value === "unavailable") {
            this.closest('.productAddonsItem').querySelector('.productAddonsItemCheckInput').checked = false;
        }
    })
})

productPage.querySelectorAll('.productAddonsItemDialogSelect')?.forEach(select => {
    select.addEventListener('change', function () {
        addOnImages(this);
        this.closest('.productAddonsItem').querySelector('.productAddonsItemSelect').selectedIndex = this.selectedIndex;
    })
})

function addOnImages(element) {
    const parent = element.closest('.productAddonsItem');
    // item change
    parent.querySelector('.productAddonsItemImage.active').classList.remove('active');
    parent.querySelector(`.productAddonsItemImage[data-index="${element.selectedIndex}"]`).classList.add('active');
    // dialog change
    parent.querySelector('.productAddonsItemDialogImage.active').classList.remove('active');
    parent.querySelector(`.productAddonsItemDialogImage[data-index="${element.selectedIndex}"]`).classList.add('active');
    // uncheck if unavailable
    if (element.value === "unavailable") {
        parent.querySelector('.productAddonsItemCheckInput').checked = false;
    }
}

productPage.querySelectorAll('.productAddonsItemCheckInput')?.forEach(input => {
    input.addEventListener('change', function () {
        if (this.closest('.productAddonsItem').querySelector('.productAddonsItemSelect').value === "unavailable") {
            this.checked = false;
        }
    })
})

/*************
 Product ATC
 ************/

// main product
productATCButton?.addEventListener("click", async function () {

    // if an inactive variant is selected, interrupt and open notification form
    if (this.classList.contains('notification')) {
        // open notification Modal
        openModal(notificationModal);
        return;
    }

    let formData;

    // add loading animation
    this.classList.add("loading");

    formData = {
        items: [{
            quantity: quantity,
            id: activeVariant.id,
        }]
    };

    // addons
    productPage.querySelectorAll('.productAddonsItemCheckInput:checked')?.forEach(input => {
        formData.items.push({
            quantity: 1,
            id: +input.closest('.productAddonsItem').querySelector('.productAddonsItemSelect').value,
        })
    })

    // add product
    try {
        await addProduct(formData);
    } catch (e) {
        // failed to atc
        console.error(e);
    }

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    try {
      if (typeof openCart !== 'undefined') await openCart();
    } catch (e) {
        // failed to atc
        console.error(e);
    }
});

/******************
 -- Recently Viewed
 ******************/

// pull recently viewed from local storage and add unless already there
let recentlyViewedStorage = localStorage.getItem("recently-viewed")
// if there is no recently-viewed, create one
const recentlyViewed = recentlyViewedStorage ? JSON.parse(recentlyViewedStorage) : [];
// check if product is already added
const filteredRecent = recentlyViewed.filter(item => item.title !== product.title)
if (filteredRecent.length === recentlyViewed.length) {
    // if not add
    recentlyViewed.push(product)
    // keeping it at the last four viewed
    while (recentlyViewed.length > 4) {
        recentlyViewed.shift()
    }
    localStorage.setItem("recently-viewed", JSON.stringify(recentlyViewed))
}

// Signature Weft selected variant cart payload guard
(function(){
  if (window.__signatureWeftSelectedVariantFetchGuard) return;
  window.__signatureWeftSelectedVariantFetchGuard = true;
  var addonIds = { '52240633037087': true };

  function currentSelectedVariantId(){
    try { if (typeof activeVariant !== 'undefined' && activeVariant && activeVariant.id) return String(activeVariant.id); } catch(e) {}
    try { var urlId = new URLSearchParams(window.location.search).get('variant'); if (urlId) return String(urlId); } catch(e) {}
    var form = document.querySelector('#productATCContainer form[action*="/cart/add"], form[action*="/cart/add"]');
    if (form) {
      var checked = form.querySelector('input[name="id"]:checked');
      if (checked && checked.value) return String(checked.value);
      var field = form.querySelector('select[name="id"], input[name="id"]');
      if (field && field.value) return String(field.value);
    }
    var btn = document.getElementById('productATC');
    return btn && btn.getAttribute('data-id') ? String(btn.getAttribute('data-id')) : null;
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch !== 'function') return;
  window.fetch = function(input, init){
    try {
      var url = (typeof input === 'string') ? input : (input && input.url);
      if (url && String(url).indexOf('/cart/add.js') !== -1 && init && typeof init.body === 'string') {
        var payload = JSON.parse(init.body);
        if (payload && Array.isArray(payload.items) && payload.items.some(function(item){ return item && addonIds[String(item.id)]; })) {
          var selectedId = currentSelectedVariantId();
          if (selectedId) {
            payload.items = payload.items.map(function(item){
              if (!item || addonIds[String(item.id)]) return item;
              return Object.assign({}, item, { id: Number(selectedId) });
            });
            init = Object.assign({}, init, { body: JSON.stringify(payload) });
          }
        }
      }
    } catch(e) {
      console.warn('[Signature Weft selected variant cart payload guard]', e);
    }
    return originalFetch.call(this, input, init);
  };
})();
